"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, LayoutGroup } from "motion/react";
import type { Tone } from "./Dot";
export function SegmentedBar(t0) {
  const $ = _c(12);
  const {
    segments,
    height: t1
  } = t0;
  const height = t1 === undefined ? 5 : t1;
  let t2;
  if ($[0] !== segments) {
    t2 = segments.reduce(_temp, 0) || 1;
    $[0] = segments;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const total = t2;
  let t3;
  if ($[2] !== height) {
    t3 = {
      height
    };
    $[2] = height;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== segments || $[5] !== total) {
    let t5;
    if ($[7] !== total) {
      t5 = s_0 => <motion.div key={s_0.tone} layout={true} data-seg="" data-tone={s_0.tone} initial={false} animate={{
        flexGrow: s_0.weight / total
      }} transition={{
        type: "spring",
        stiffness: 300,
        damping: 32
      }} className="ui-segbar-seg" style={{
        height: "100%",
        flexBasis: 0,
        flexShrink: 1
      }} />;
      $[7] = total;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = segments.map(t5);
    $[4] = segments;
    $[5] = total;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <LayoutGroup><div className="ui-segbar" style={t3}>{t4}</div></LayoutGroup>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(s, x) {
  return s + x.weight;
}